/**
 * Javascript lié aux pages offres d'emploi (Recherche et Détail d'une offre)
 */

import './form';
import './components/custom-dropdown';

(function (w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({}, w.Completude, {
        
        paginationClick:false,
        offresdemploi: {            
                        
            /**
             * Initialisation du module de recherche d'offre d'emploi
             * @returns 
             */
            InitRechercheOffresEmploi: function()
            {                                
                // Clic sur le bouton "Rechercher" (recherche d'offre) ou "Valider" filtre des niveauxx
                jQuery('#search-offers-block,#btn-filter-niveau').on('click', function (event) {
                    event.preventDefault();
                    $(this).closest('[data-closable-item]').removeClass('visible');
                    $(this).closest('[data-closable-item]').find('.google-map').removeAttr('style');
                    
                    if (Completude.offresdemploi.$form.validate()) {
                        Completude.offresdemploi.Rechercher(window.autocomplete.localisation, 1,false);               
                    }                     
                });
                
                // Clic sur un bouton de pagination ( < 1,2,3 >)
                jQuery(document).on('click', '.to-page,.paging__next,.paging__prev', function () {
                    let p = Completude.offresdemploi.getPageClick(this);
                    Completude.offresdemploi.Rechercher(window.autocomplete.localisation,p,false);
                });
 
                // //Clic sur le bouton "Fitrer par classe"
                jQuery("#btn-filtrer").on('click', function (event) {
                    event.preventDefault();
                    var modalTarget = $(this).data('modal-target');                            
                    $(modalTarget).addClass('visible');
                    //lockScroll($(modalTarget));
                });
                
                // Fermeture de la popup des filtres
                jQuery('[data-close-item]').on('click', function (event) {
                    event.preventDefault();            
                    $(this).closest('[data-closable-item]').removeClass('visible');            
                    $(this).closest(".main.visible").removeClass('visible');
                    //$(this).closest('[data-closable-item]').find('.google-map').removeAttr('style');
                    //lockScroll($('[data-closable-item]'));
                });

                //Clic sur le bouton "liste" ou "fermeture carte"
                jQuery('.btn-list,#results-map .btn-close').on('click',function() {
                    jQuery('.btn-map').show();
                    jQuery('#results-map').hide();
                    jQuery('#results-list').show();
                    jQuery('#results-map').removeClass('visible').removeClass('map-loaded');
                });

                // Clic sur le bouton "Carte"                
                jQuery('.btn-map').on('click', function (event) {                    
                    event.preventDefault();
                    if (Completude.offresdemploi.$form.validate()) {
                        $(this).closest(".main").addClass('visible');
                        Completude.offresdemploi.Rechercher(window.autocomplete.localisation, 1,true);               
                    }
                });

                // Init du form du bloc de recherche
                Completude.offresdemploi.$form = Completude.SetFormValidation(jQuery('#recherche-offres-form'));                   

                let filtreRecherche = Completude.GetStorage('search-offers');
                                   
                //Initialisation du custom dropdown avec les matières précochées
                jQuery(".js-custom-dropdown").CustomDropdown(filtreRecherche !== null && typeof filtreRecherche.matieres !== 'undefined' ? filtreRecherche.matieres : null );
                
                if (typeof(filtreRecherche)!=='undefined' && filtreRecherche!==null && typeof filtreRecherche.localisation!='undefined' && filtreRecherche.localisation!==null) {
                    // Recherche précédente                                 
                    jQuery("#field-address").SetLocalisation(filtreRecherche.localisation);                    
                    Completude.offresdemploi.Rechercher(filtreRecherche.localisation,typeof(filtreRecherche.page)!=='undefined' ? filtreRecherche.page : 1,false);

                } else {
                    // Pas de recherche précédente
                    Completude.offresdemploi.Rechercher(null,1,false);       
                }                                        

                let hash = location.hash.replace('#', ''); 
                
            },

            /**
             * Init du module de détail d'une offre d'emploi
             */
            InitDetailOffreEmploi : function() {
                window.Completude.offresdemploi.loadAjaxOffer();
                jQuery('#offer').on('click', '.add-offer', function (e) {
                    Completude.offresdemploi.clickPostulerOffre(e);
                });
            },                                                      

            /**
             * Recherche des offres d'emplois
             * @param {*} place 
             * @param {*} subjects 
             * @param {*} levels 
             * @param {*} page 
             * @param {*} map 
             */
            loadAjaxOffers: function (localisation, matieres, niveaux, p, map) {

                let postdata = {
                    'action'  : 'wp_get_offers',
                    'lat'     : null,
                    'lng'     : null,
                    'subjects': matieres,
                    'levels'  : niveaux,
                    'page'    : p,
                    'map'     : map
                }

               if (typeof localisation!=='undefined' && localisation!==null) {
                    postdata.lat = localisation.lat;
                    postdata.lng =localisation.lng;
               }                

                // Attribut du bouton map
                let $btnMapOffers = jQuery('.btn-map-offers');
                $btnMapOffers.data('place',     localisation);
                $btnMapOffers.data('subjects',  matieres);
                $btnMapOffers.data('levels',    niveaux);                                             
                
                // Gestion de la carte
                if (map===false) {
                    jQuery('.loader').show();
                    jQuery('#results-list').hide(); // Bloc liste avec la pagination
                    jQuery('#offers-list').empty(); // Liste des offres
                    jQuery('#results-map').hide();
                    jQuery('.paging').empty();
                    jQuery('.offer-error').addClass('hide');
                    jQuery('.error-noJob').addClass('hide');
                } else {
                    jQuery('.loader').show();
                    jQuery('#results-list').hide();
                    jQuery('#results-map').hide();
                    jQuery('.google-map').addClass('overlay');
                } 
                               
                jQuery.ajax({
                    url : disko_ajax_object.ajaxurl,
                    type: 'post',
                    data: postdata,
                    success: function (response) {                                            
                        
                        if (!response.success) {
                            // Erreur  Commune non désservie                          
                            jQuery('.error-noJob').removeClass('hide');
                            jQuery('.offer-error').addClass('hide');
                            jQuery('.loader').hide();
                            Completude.offresdemploi.disableOffersMap();
                            Completude.TagManagerTunnel('offres/step-1',{event : 'DisplayOfferListNotAvailable'});
                            return false;
                        } 
                        else if (0 == response.data.length) { 
                            // Pas d'offre d'emploi (filtre trop restrictif)                          
                            jQuery('.offer-error').removeClass('hide');
                            jQuery('.error-noJob').addClass('hide');
                            jQuery('.loader').hide();
                            Completude.offresdemploi.disableOffersMap();

                            Completude.TagManagerTunnel('offres/step-1',{event : 'DisplayOfferListEmpty'});
                            return false;
                        } 
                                             

                        // Gestion des offres déjà vues
                        let seenOffers = JSON.parse(Completude.GetStorage('seen_offers'));
                        if (null !== seenOffers) {
                            for (let i = 0; i < response.data.length; i++) {
                                if (-1 !== seenOffers.indexOf(response.data[i].id)) {
                                    response.data[i].seen = true;
                                }
                            }
                        }

                        // Gestion des offres déjà postulées
                        let appliedOffers = JSON.parse(Completude.GetStorage('applied_offers'));
                        if (null !== appliedOffers) {
                            for (let i = 0; i < response.data.length; i++) {
                                if (-1 !== appliedOffers.indexOf(response.data[i].id)) {
                                    response.data[i].applied = true;
                                }
                            }
                        }

                        if (map===true) {
                            // Affichage de la carte
                            let mapContainer = jQuery('.google-map');
                            jQuery('#results-map').addClass('map-loaded');                            
                            mapContainer.data('location-lat', localisation.lat);
                            mapContainer.data('location-lng', localisation.lng);
                            initMap(mapContainer, response.data, true, localisation.lat, localisation.lng);
                            mapContainer.removeClass('overlay');
                            jQuery('#results-map').show();
                        } else {
                            response.page = p;

                            // Mise à jour de l'agence par défaut
                            if (postdata.lat && postdata.lng && response.data[0].agency && response.data[0].agency != null && p == 1) {
                                window.Completude.UpdateAgence(response.data[0].agency.id);  
                                if(Completude.isNewAgence(response.data[0].agency.id) && response.data.length<Completude.settings.nouvelles_agences_max_offres)  {
                                    // redirection vers postuler si <20
                                    window.location = "/postuler/";
                                    return;
                                }
                            }

                            // Affichage des offres en mode liste
                            let resultContent  = jQuery('#offers-list');
                            let resultTemplate = jQuery('#offers-template');
                            let template = Handlebars.compile(resultTemplate.html());
                            resultContent.data('page', p).data('length', response.data[0].nbRows).empty().html(template(response));
                            location.hash = p;

                            Completude.offresdemploi.computePagination();
                            
                            jQuery('#results-list').show();
                            // Gestion du positionnement sur l'annonce d'id offerid lors d'un retour à la liste depuis le détail d'une offre
                            let offerId = jQuery.urlParam('offerid');
                            if (!offerId && window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
                                //get last seeenOffer for browser back
                                offerId = (seenOffers != null) ? 'offer-' + seenOffers[seenOffers.length - 1] : null;
                            }
                           

                            jQuery('.error-noJob').addClass('hide');
                            if (jQuery('#field-address').val().length > 0) {
                                jQuery('.btn-map').show();
                            }

                        }
                                                
                        Completude.TagManagerTunnel('offres/step-1');
                        Completude.TagManagerTunnel('offres/step-1',{event : 'DisplayOfferListFull'});

                    },
                    complete: function () {
                        jQuery('.loader').hide();
                    }
                });
            },
            /**
             * Chargement Ajax du détail d'une offre d'emploi
             */
            loadAjaxOffer: function () {
                jQuery('.loader').show();

                let id     = parseInt(jQuery('#offer').data('offer-id'));              
                let search = Completude.GetStorage('search-offers');
                                
                jQuery.ajax({
                    url: disko_ajax_object.ajaxurl,
                    type: 'post',
                    data: {
                        'action': 'wp_get_offer',
                        'lat': search ? search.localisation.lat : null,
                        'lng': search ? search.localisation.lng : null,
                        'id': id
                    },
                    success: function (response) {
                        if (!response.success) {

                            // Si erreur
                            if (typeof response.data.CodeErreur != typeof undefined) {
                                let resultContent  = jQuery('#offer');
                                let resultTemplate = jQuery('#offer-template-error');
                                let template       = Handlebars.compile(resultTemplate.html());
                                resultContent.html(template(response.data));

                                jQuery('.loader').hide();
                            }
                            return false;
                        }

                        let data = JSON.parse(response.data);

                        // Test si offre déjà postulé
                        let appliedOffers = JSON.parse(Completude.GetStorage('applied_offers'));

                        if (appliedOffers && -1 != appliedOffers.indexOf(id)) {
                            data.applied  = true;
                            let postuler = Completude.GetStorage('form-postuler');
                            data.name     = postuler.prenom;
                            data.ref      = jQuery('#offer').data('offer-id');
                        }

                        // Map des données sur le html (TODO à revoir)
                        let resultContent  = jQuery('#offer');
                        let resultTemplate = jQuery('#offer-template');
                        let template       = Handlebars.compile(resultTemplate.html());
                        resultContent.html(template(data));                                            

                        // Retour à la recherche
                        if(null == search) {                            
                            Completude.SetStorage('search-offers', {localisation : { lat : data.latitude , lng : data.longitude , formatted_address : data.prefillValue }});                            
                            jQuery('#commune').html("Voir d'autres offres à proximité de " + data.city);
                        } else {
                            jQuery('#commune').html("Retour à la liste");
                        }

                        // Gestion de la map
                        let mapContainer = jQuery('.google-map');
                        mapContainer.each(function () {
                            jQuery(this).data('location-lat', search ? search.lat : null);
                            jQuery(this).data('location-lng', search ? search.lng : null);
                            initMap(jQuery(this), null, null, data.latitude, data.longitude);
                        });

                        // Ajoute l'id de l'offre dans la liste des offres déjà vues
                        let seenOffers = JSON.parse( Completude.GetStorage('seen_offers') );
                        if (null === seenOffers || -1 === seenOffers.indexOf(id)) {
                            seenOffers = (seenOffers || []).concat([id])
                        }
                        Completude.SetStorage('seen_offers', JSON.stringify(seenOffers),7);                                                

                        jQuery('.loader').hide();
                        Completude.TagManagerTunnel('offres/step-2');
                    }
                });
            },
            

            /**
             * Clic sur le bouton "Postuler à cette offre" sur la page "Détail d'une offre"
             * @param {*} e 
             */
            clickPostulerOffre: function (e)
            {
                // Identifiant de l'offre
                let id  = jQuery('#offer').data('offer-id');
                let securitykey =  Completude.GetStorage('postuler-security-key');
                e.preventDefault();                                

                // Si on as une "security key" c'est qu'une candidature précédente à été faites
                // on utilise wp_add_offer pour ajouter l'id de l'offre à la candidature précédente
                if (securitykey!==null && typeof(securitykey)!='undefined') {                    
                    // Ajout de l'id à la candidature précédente
                    $('#offer .offer__inner').loading(
                    jQuery.ajax({
                        url : disko_ajax_object.ajaxurl,
                        type: 'post',
                        data: {
                            action: 'wp_add_offer',
                            nonce : disko_ajax_object.nonce,
                            id    : id,
                            key   : securitykey,
                        },
                        success: function (response) {
                            if (response.success && typeof undefined == typeof response.data.ErreurMetier) {
                                jQuery('.offer__actions').remove();

                                let resultContent = jQuery('.offer__foot');
                                let template      = Handlebars.compile(resultContent.html());
                                let ref           = jQuery('#offer').data('offer-id');

                                
                                let data = {
                                    prenom: response.data.Prenom,
                                    jobId: ref
                                };
                                
                                jQuery('#offer').append(template({
                                    name: data.prenom,
                                    ref: data.jobId
                                }));
                                
                                // Mise à jour des offres postulées
                                let appliedOffers   = JSON.parse(Completude.GetStorage('applied_offers'));
                                
                                if (null === appliedOffers || -1 === appliedOffers.indexOf(dataFormApply.jobId)) {
                                    appliedOffers = (appliedOffers || []).concat([ref]);
                                }                                                                                                                                
                                Completude.SetStorage( 'applied_offers', JSON.stringify(appliedOffers),15);
                                // Scroll pour voir le message si necessaire
                                jQuery('.notice').first().scrollToElementIfNonVisible();
                                                                
                            }
                        }
                    }));
                } 
                else {
                    // Sinon, on redirige vers le formulaire postuler                   
                    Completude.TagManagerTunnel('postuler/step-0');
                    document.location.href= window.location.origin + "/postuler/" + id; 
                }

            },
            
            /**
             * Clic sur le bouton "Carte"
             */
            clickOfferMapMarker: function ()
            {
                let $btnMapOffers = jQuery('.btn-map-offers');
                let place         = JSON.parse($btnMapOffers.data('place'));
                Completude.offresdemploi.paginationClick = false;
                if (typeof place != undefined) {
                    let subjects = $btnMapOffers.data('subjects');
                    let levels   = $btnMapOffers.data('levels');
                    autocomplete.set('place', place);
                    window.Completude.offresdemploi.loadAjaxOffers(place, subjects, levels, 1, true);
                }
            },
            
            /**
             * Clic sur le bouton "Rechercher"
             * @returns 
             */
            Rechercher: function(localisation,page,map)
            {                
                Completude.offresdemploi.disableOffersMap();
                jQuery('#results-map').removeClass('visible').removeClass('map-loaded');
                Completude.offresdemploi.paginationClick = false;                
                let matieres  = [],
                    niveaux    = []; 
                var trackingfiltre = {'event' : 'FilterResult','Primaire': false,'College': false,'Lycee': false, 'Superieur':false};            

                // Filtre matière
                jQuery('input[name="subjects"]:checked').each(function () {
                    matieres.push(this.value)
                });

                // Filtre niveaux
                jQuery('input[name="levels"]:checked').each(function () {
                    niveaux.push(this.value);
                    trackingfiltre = Object.assign(trackingfiltre,{[this.value]: true});
                });
                if (niveaux.length > 0) {
                    jQuery('#filter-class button.dropdown__toggle').addClass('checked');                    
                    console.debug('dataLayer.push: ' + JSON.stringify(trackingfiltre));     
                    dataLayer.push(trackingfiltre);           
                } else {
                    jQuery('#filter-class button.dropdown__toggle').removeClass('checked');
                } 
                
                
                /* Sauvegarde la recherche */
                Completude.SetStorage('search-offers',  {localisation : localisation, matieres : matieres , niveaux :  niveaux , page : page});                
                window.Completude.offresdemploi.loadAjaxOffers(localisation, matieres, niveaux, page ,map);
               
            },                   
            

            /**
             * Retourne le N° de page clické ou à charger
             */
            getPageClick : function(target) {
                let p = null;
                if (jQuery(target).data('page')) {
                    p = jQuery(target).data('page');
                } else if (jQuery(target).hasClass('paging__next')) {
                    p = jQuery('#offers-list').data('page') + 1;
                } else if (jQuery(target).hasClass('paging__prev')) {
                    p = jQuery('#offers-list').data('page') - 1;
                }
                return p;
            } ,
           
            
            disableOffersMap: function () {
                jQuery('.btn-map').hide();
                jQuery('.btn-list').show();                
                jQuery('#results-map').removeClass('visible').removeClass('map-loaded');
                jQuery('#results-list').addClass('visible');

            },
            
            computePagination: function () {
                let paginationContent = jQuery('.paging');
                let resultContent = jQuery('#offers-list');
                let nbItems = resultContent.data('length');
                let nbPages = Math.ceil(nbItems / 20);
                let p = resultContent.data('page');

                paginationContent.empty();

                let pages = [];
                if (p > 2 && p < nbPages - 2) {
                    pages = [{value: p - 2}, {value: p - 1}, {value: p, current: true}, {value: p + 1}, {value: p + 2}];
                } else if (p <= 5) {
                    pages = [];

                    for (let i = 1; i <= (nbPages <= 5 ? nbPages : 5); i++) {
                        pages.push({value: i});
                    }
                } else {
                    pages = [{value: nbPages - 4}, {value: nbPages - 3}, {value: nbPages - 2}, {value: nbPages - 1}, {value: nbPages}];
                }

                for (let i = 0; i < pages.length; i++) {
                    if (p == pages[i].value) {
                        pages[i].current = true;
                    }
                }

                paginationContent      = jQuery('.paging');
                let paginationTemplate = jQuery('#paging-template');
                let template           = Handlebars.compile(paginationTemplate.html());
                let data               = {
                    pages      : pages,
                    nbPages    : nbPages,
                    currentPage: p,
                    nextPage   : p + 1,
                    prevPage   : p - 1,
                    displayPrev: (p > 1),
                    displayNext: (p < nbPages)
                };

                paginationContent.html(template(data));

                jQuery('.offer-error').show();
            }
            
        }
    });
})(window);

jQuery(function() {
    if (jQuery("#pageOffers").length > 0) {
        window.Completude.offresdemploi.InitRechercheOffresEmploi();
    }
    if (jQuery("#pageOffer").length > 0) {
        window.Completude.offresdemploi.InitDetailOffreEmploi();
    }
});





